import { useCallback, useState } from "react";

const useAsyncError = () => {
  const [, setError] = useState();
  const handleSetError = useCallback(
    (error) => {
      setError(() => {
        throw error;
      });
    },
    [setError]
  );
  return handleSetError;
};

export default useAsyncError;
